module.exports = __webpack_public_path__ + "static/media/Streetwear_thumb.c1ed1799.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/trends/Streetwear_thumb.png
// module id = 347
// module chunks = 0